import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaHome, FaProjectDiagram, FaFlagCheckered, FaTrophy, FaBars, FaTimes } from 'react-icons/fa';
import './NavBar.css';
import logo from '../../assets/img/LogoTorneoFC.png';

const NAV_LINKS = [
  { to: '/', label: 'Inicio', icon: <FaHome /> },
  { to: '/knockout', label: 'Eliminatorias', icon: <FaProjectDiagram /> },
  { to: '/semifinal', label: 'Final', icon: <FaFlagCheckered /> },
  { to: '/winner', label: 'Ganador', icon: <FaTrophy /> },
];

const NavBar = () => {
  const { pathname } = useLocation();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 12);
    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMenuOpen(false);
  }, [pathname]);

  return (
    <nav className={`navbar ${isScrolled ? 'navbar--scrolled' : ''}`}>
      <div className="navbar-bar">
        <Link to="/" className="navbar-logo">
          <img src={logo} alt="Logo Torneo FC" />
          <span>Torneo FC 26</span>
        </Link>

        <button
          type="button"
          className="navbar-toggle"
          onClick={() => setIsMenuOpen((open) => !open)}
          aria-expanded={isMenuOpen}
          aria-label={isMenuOpen ? 'Cerrar menú' : 'Abrir menú'}
        >
          {isMenuOpen ? <FaTimes /> : <FaBars />}
        </button>
      </div>

      <ul className={`navbar-links ${isMenuOpen ? 'navbar-links--open' : ''}`}>
        {NAV_LINKS.map((link) => (
          <li key={link.to}>
            <Link to={link.to} className={pathname === link.to ? 'active' : ''}>
              <span className="navbar-links__icon">{link.icon}</span>
              <span>{link.label}</span>
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default NavBar;
